(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
 document.addEventListener('DOMContentLoaded', () => {
  const stickyEl =
    document.querySelector('#shopify-section-header sticky-header.header-wrapper') ||
    document.querySelector('sticky-header.header-wrapper');

  if (!stickyEl) {
    console.warn('[Sticky] sticky-header not found');
    return;
  }

  const setHeight = () => {
    document.documentElement.style.setProperty('--sticky-h', `${stickyEl.offsetHeight}px`);
  };

  const onScroll = () => {
    const shouldStick = window.scrollY > 0;
    stickyEl.classList.toggle('is-sticky', shouldStick);
    document.body.classList.toggle('has-sticky-header', shouldStick);
  };

  // init
  setHeight();
  onScroll();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => {
    setHeight();
    onScroll();
  }, { passive: true });

  console.log('[Sticky] enabled on', stickyEl);
});


document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector(
    '#shopify-section-header sticky-header.header-wrapper'
  );
  if (!wrapper) return;

  const btn = wrapper.querySelector('.sticky-search-toggle');
  const searchLine = wrapper.querySelector('.head-search-line');
  const input = wrapper.querySelector(
    '.head-search-line input[type="search"], .head-search-line input[type="text"]'
  );

  if (!btn || !searchLine || !input) return;

  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  const openSearch = () => {
    if (!isDesktop()) return;
    wrapper.classList.add('search-open');
    btn.setAttribute('aria-expanded', 'true');

    requestAnimationFrame(() => {
      setTimeout(() => input.focus({ preventScroll: true }), 300);
    });
  };

  const closeSearch = () => {
    wrapper.classList.remove('search-open');
    btn.setAttribute('aria-expanded', 'false');
  };

  btn.addEventListener('click', () => {
    if (!isDesktop()) return;
    wrapper.classList.contains('search-open')
      ? closeSearch()
      : openSearch();
  });

  /* ESC closes */
  wrapper.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });

  /* Resize safety: close if leaving desktop */
  window.addEventListener('resize', () => {
    if (!isDesktop()) closeSearch();
  });
});


  } catch(e) { console.error(e); }
})();
})();
